<div class="bc-email-control-panel" [@slideInFromBottomAnimation]>
  <div class="container-fluid">
    <div class="control-panel-groups">
      <div class="control-panel-group control-panel-group-send two-columns">
        <button (click)="onReplyClick()" class="btn btn-dark js-reply-email-button" id="email-control-panel-reply">
          <span>{{ 'bcEmailControlPanel.reply' | translate }}</span>
        </button>
        <button (click)="onForwardClick()"
                class="btn btn-light js-forward-email-button"
                id="email-control-panel-forward"
                [attr.data-automation-id]="'bc-email-control-forward'">
          <span>{{ 'bcEmailControlPanel.forward' | translate }}</span>
        </button>
        <button (click)="onReplyAllClick()" class="btn btn-light js-reply-all-email-button" id="email-control-panel-reply-all">
          <span>{{ 'bcEmailControlPanel.replyAll' | translate }}</span>
        </button>
      </div>
      <div class="control-panel-group control-panel-group-action two-columns">
        <button (click)="onDiscussionsClick()" *ngIf="showDiscussionButton" [disabled]="isDiscussionButtonDisabled"
                class="btn btn-light js-discuss-email-button" id="email-control-panel-discussions">
          <span>{{ 'bcEmailControlPanel.discuss' | translate }}</span>
        </button>
        <button (click)="onTransferClick()" class="btn btn-light js-assign-email-button" id="email-control-panel-transfer">
          <span>{{ 'bcEmailControlPanel.assign' | translate }}</span>
        </button>
        <button *ngIf="hasWrapUps" (click)="onWrapUpClick()" class="btn btn-light js-wrap-up-button" id="email-control-panel-wrap-up">
          <span>{{ 'bcEmailControlPanel.wrapUp' | translate }}</span>
        </button>
        <button (click)="onCloseClick()" class="btn btn-light js-close-email-button" id="email-control-panel-close">
          <span>{{ 'bcEmailControlPanel.closeNow' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
